import { useEffect, useId } from 'react';
import { useRachelStore } from '../store/rachel.store';

export const useRachelFocusedLabel = (label?: string | null) => {
  const publisherId = useId();

  useEffect(() => {
    if (!label) {
      return;
    }

    const { publishFocusedLabel, unpublishFocusedLabel } = useRachelStore.getState();
    publishFocusedLabel({ publisherId, label });
    return () => unpublishFocusedLabel(publisherId);
  }, [publisherId, label]);
};
